import { useRouter } from "next/router";
import Link from "next/link";

const LawyerBottomNavbar = ({ navItems, handleProtectedRouteClick }) => {
    const router = useRouter(); // To get the current route

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-lawyer-primary shadow-lg border-t border-white/20 py-2 z-50">
            <div className="flex justify-around items-center">
                {navItems.map(({ title, icon, href }) => {
                    const isActive = router.pathname === href; // Check if the tab is active
                    return (
                        <Link
                            prefetch={false}
                            key={title}
                            href={href}
                        >
                            <a className={`flex flex-col items-center text-sm text-white ${isActive ? " font-bold" : "opacity-80"
                                }`}>

                                <button onClick={(e) => handleProtectedRouteClick?.(e, href)} className={`text-2xl ${isActive ? "" : " opacity-80"}`} aria-label={title}>
                                    {icon}
                                </button>
                                <button onClick={(e) => handleProtectedRouteClick?.(e, href)} className="text-sm text-white">
                                    {title}
                                </button>
                            </a>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default LawyerBottomNavbar;
